import { useEffect, useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayoutMin from "examples/LayoutContainers/DashboardLayoutMin";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import DynamicDialog from "components/MDDialog";
import LogoDialog from "components/MDLogoDialog";
import { hasPermission } from "../../../utils/hasPermissions";
import fetchTableData from "../../../utils/fetchTableData";
import RowSocietyActionsMenu from "./RowSocietyActionsMenu";
import RowCollegeActionsMenu from "./RowCollegeActionsMenu";
import RowProgramActionsMenu from "./RowProgramActionsMenu";
import RowBranchActionsMenu from "./RowBranchActionsMenu";
import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
function SocietyClient() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const ActiveStatusCell = ({ value }) => (
    <Chip
      label={value === "ACTIVE" || value === true || value === 1 ? "Active" : "Inactive"}
      color={value === "ACTIVE" || value === true || value === 1 ? "success" : "error"}
      size="small"
      variant="outlined"
    />
  );
  ActiveStatusCell.propTypes = {
    value: PropTypes.number.isRequired,
  };
  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };
  const [user, setUser] = useState(null);
  const [logoDialogOpen, setLogoDialogOpen] = useState(false);
  const [existUrl, setExistsUrl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [scolumns, setSColumns] = useState([]);
  const [srows, setSRows] = useState([]);
  const [sopen, setSOpen] = useState(false);
  const [seditingId, setSEditingId] = useState(null);
  const [societyFormErrors, setSocietyFormErrors] = useState({});
  const [societyFormData, setSocietyFormData] = useState({
    society_id: "",
    society_name: "",
    society_email: "",
    society_code: "",
    is_society_active: "",
    client_id: "",
  });
  const [sucolumns, setSUColumns] = useState([]);
  const [surows, setSURows] = useState([]);
  const [suopen, setSUOpen] = useState(false);
  const [sueditingId, setSUEditingId] = useState(null);
  const [societyUserFormErrors, setSocietyUserFormErrors] = useState({});
  const [societyUserFormData, setSocietyUserFormData] = useState({
    society_id: "",
    society_name: "",
    is_user_active: "",
    user_email: "",
    user_email: "",
  });
  const [cucolumns, setCUColumns] = useState([]);
  const [curows, setCURows] = useState([]);
  const [cuopen, setCUOpen] = useState(false);
  const [cueditingId, setCUEditingId] = useState(null);
  const [collegeUserFormErrors, setCollegeUserFormErrors] = useState({});
  const [collegeUserFormData, setCollegeUserFormData] = useState({
    college_id: "",
    college_name: "",
    is_user_active: "",
    user_email: "",
    user_email: "",
  });
  const [ccolumns, setCColumns] = useState([]);
  const [crows, setCRows] = useState([]);
  const [copen, setCOpen] = useState(false);
  const [openCollegesData, setOpenCollegesView] = useState(false);
  const [ceditingId, setCEditingId] = useState(null);
  const [societyId, setSocietyId] = useState(null);
  const [societyName, setSocietyName] = useState(null);
  const [collegeId, setCollegeId] = useState(null);
  const [collegeName, setCollegeName] = useState(null);
  const [programId, setProgramId] = useState(null);
  const [programName, setProgramName] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [branchName, setBranchName] = useState(null);
  const [collegeFormErrors, setCollegeFormErrors] = useState({});
  const [collegeFormData, setCollegeFormData] = useState({
    society_id: "",
    college_name: "",
    is_college_active: "",
    college_code: "",
    college_refurl: "",
    college_email: "",
    college_validity: "",
    db_instance_id: "",
    college_logourl: "",
  });
  const [cpcolumns, setCPColumns] = useState([]);
  const [cprows, setCPRows] = useState([]);
  const [cpopen, setCPOpen] = useState(false);
  const [cpview, setCPView] = useState(false);
  const [cpeditingId, setCPEditingId] = useState(null);
  const [collegeProgramFormErrors, setCollegeProgramFormErrors] = useState({});
  const [collegeProgramFormData, setCollegeProgramFormData] = useState({
    college_id: "",
    college_name: "",
    is_program_active: "",
    program_name: "",
    program_desc: "",
    program_duration: "",
  });
  const [pbcolumns, setPBColumns] = useState([]);
  const [pbrows, setPBRows] = useState([]);
  const [pbopen, setPBOpen] = useState(false);
  const [pbview, setPBView] = useState(false);
  const [pbeditingId, setPBEditingId] = useState(null);
  const [programBranchFormErrors, setProgramBranchFormErrors] = useState({});
  const [programBranchFormData, setProgramBranchFormData] = useState({
    program_id: "",
    college_id: "",
    branch_name: "",
    is_branch_active: "",
    branch_start_year: "",
    branch_desc: "",
  });
  const [abcolumns, setABColumns] = useState([]);
  const [abrows, setABRows] = useState([]);
  const [abopen, setABOpen] = useState(false);
  const [abview, setABView] = useState(false);
  const [abeditingId, setABEditingId] = useState(null);
  const [admissionBatchFormErrors, setAdmissionBatchFormErrors] = useState({});
  const [admissionBatchId, setAdmissionBatchId] = useState(null);
  const [admissionBatchName, setAdmissionBatchName] = useState(null);
  const [admissionBatchFormData, setAdmissionBatchFormData] = useState({
    college_id: "",
    admissionbatch_year: "",
    is_active: "",
    delete_status: "",
  });
  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchSocieties();
    }
  }, [user]);

  const fetchSocieties = async () => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/societies/${user.client_id}`,
      onEdit: handleSocietyEdit,
      onExtraAction: {
        onCreateSocietyUser: openSocietyUserDialog,
        onViewColleges: openCollegesView,
        db_instance_id: user.db_instance_id,
        hasPermission,
      },
      setColumns: setSColumns,
      setRows: setSRows,
      customActionComponent: (props) => (
        <RowSocietyActionsMenu
          {...props}
          onCreateSocietyUser={props.onExtraAction?.onCreateSocietyUser}
          onViewSocietyUsers={props.onExtraAction?.onViewSocietyUsers}
          onViewColleges={props.onExtraAction?.onViewColleges}
          db_instance_id={props.onExtraAction?.db_instance_id}
          hasPermission={props.onExtraAction?.hasPermission}
        />
      ),
    });
  };

  const handleSocietyEdit = (row) => {
    setSocietyFormData({ ...row });
    setSEditingId(row.society_id);
    setSOpen(true);
  };
  const handleFeeCategoryDelete = async (feecategory_id) => {
    let res;
    res = await axios.post(
      `${API_BASE_URL}/bootstrap-feetype.php?action=list&feecategory_id=${feecategory_id}&db_instance_id=${user.db_instance_id}`,
      null,
      {
        headers: getAuthHeaders(),
      }
    );
    if (Array.isArray(res.data)) {
      const confirm = await Swal.fire({
        title: "Fee types Already Exists for this FeeCategory?",
        icon: "warning",
        confirmButtonText: "Close!",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) {
            container.style.zIndex = "20000";
          }
        },
      });
    } else if (res.data.success === false) {
      const confirm1 = await Swal.fire({
        title: "Sure to delete FeeCategory?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        willOpen: () => {
          const container = document.querySelector(".swal2-container");
          if (container) {
            container.style.zIndex = "20000";
          }
        },
      });

      if (confirm1.isConfirmed) {
        let response;
        try {
          response = await axios.post(
            `${API_BASE_URL}/bootstrap-feecategory.php?action=delete&feecategory_id=${feecategory_id}&db_instance_id=${user.db_instance_id}`,
            null,
            {
              headers: getAuthHeaders(),
            }
          );
          if (response.status === 200) {
            showSnackbar(" Fee Category Deleted successfully", "success");
          } else {
            showSnackbar(" Fee Category is not Deleted ", "error");
          }
          fetchFeeCategories();
        } catch (err) {
          alert(err);
          showSnackbar("Error deleting Fee Category", "error");
        }
      }
    }
  };
  const handleSocietySave = async () => {
    const errors = {};
    if (!societyFormData.society_name?.trim()) {
      errors.society_name = "Society name is required";
    }
    if (!societyFormData.society_code?.trim()) {
      errors.society_code = "Society Code is required";
    }
    if (!societyFormData.society_email?.trim()) {
      errors.society_email = "Society email is required";
    }
    if (seditingId && societyFormData.is_society_active === "") {
      errors.is_society_active = "Select status";
    }

    setSocietyFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userEmail = user?.user_email || "unknown";
    try {
      let response;
      if (seditingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-society.php?action=update`,
          {
            society_id: seditingId,
            db_instance_id: user.db_instance_id,
            client_id: user.client_id,
            updated_by: userEmail,
            is_society_active: societyFormData.is_society_active == "1" ? 1 : 0,
            ...societyFormData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        showSnackbar(message, "success");
      } else {
        showSnackbar("Something went wrong. Please try again.", "error");
      }
      setSOpen(false);
      fetchSocieties();
    } catch (error) {
      console.error("Error saving:", error);
      showSnackbar("Error saving data", "error");
    }
  };
  const openSocietyUserDialog = (society_id, society_name, db_instance_id) => {
    setSocietyUserFormData({
      society_id,
      society_name,
      db_instance_id,
      user_email: "",
      is_user_active: "",
      user_email: "",
    });
    setSUOpen(true);
    setSUEditingId(null);
    setSocietyId(society_id);
    setSocietyName(society_name);
    setSocietyUserFormErrors({});
  };
  const openCollegeUserDialog = (
    society_id,
    college_id,
    society_name,
    college_name,
    db_instance_id
  ) => {
    setCollegeUserFormData({
      society_id,
      society_name,
      college_id,
      college_name,
      db_instance_id,
      user_email: "",
      is_user_active: "",
      user_email: "",
    });
    setCUOpen(true);
    setCUEditingId(null);
    setCollegeId(college_id);
    setCollegeName(college_name);

    setSocietyUserFormErrors({});
  };
  const openCollegeProgramDialog = (college_id, college_name, db_instance_id) => {
    setCollegeProgramFormData({
      college_id,
      college_name,
      db_instance_id,
      program_name: "",
      program_desc: "",
      program_duration: "",
      is_program_active: "",
    });
    setCPOpen(true);
    setCPEditingId(null);
    setCollegeId(college_id);
    setCollegeName(college_name);
    setCollegeProgramFormErrors({});
  };
  const openAdmissionBatchDialog = (college_id, college_name, db_instance_id) => {
    setAdmissionBatchFormData({
      college_id,
      db_instance_id,
      is__active: "",
      admissionbatch_year: "",
    });
    setABOpen(true);
    setABEditingId(null);
    setCollegeId(college_id);
    setCollegeName(college_name);
    setAdmissionBatchFormErrors({});
  };
  const openProgramBranchDialog = (program_id, college_id, program_name, db_instance_id) => {
    setProgramBranchFormData({
      program_id,
      college_id,
      program_name,
      db_instance_id,
      branch_name: "",
      branch_desc: "",
      branch_start_year: "",
      is_branch_active: "",
    });
    setPBOpen(true);
    setPBEditingId(null);
    setProgramId(program_id);
    setCollegeId(college_id);
    setProgramName(program_name);
    setProgramBranchFormErrors({});
  };
  const openCollegesView = async (society_id, society_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/api/colleges/${user.client_id}/${society_id}`,
      onEdit: handleCollegeEdit,
      onExtraAction: {
        onCreateCollegeUser: openCollegeUserDialog,
        onUploadLogo: openCollegeLogoDialog,
        onCreateCollegeProgram: openCollegeProgramDialog,
        onCreateAdmissionBatch: openAdmissionBatchDialog,
        onViewCollegeUsers: openCollegeProgramDialog, //fetchCollegeUsers,
        onViewCollegePrograms: openCollegeProgramsView, //fetchCollegePrograms,
        db_instance_id: user.db_instance_id,
        hasPermission,
      },
      setColumns: setCColumns,
      setRows: setCRows,
      customActionComponent: (props) => (
        <RowCollegeActionsMenu
          {...props}
          onUploadLogo={props.onExtraAction?.onUploadLogo}
          onCreateCollegeUser={props.onExtraAction?.onCreateCollegeUser}
          onCreateCollegeProgram={props.onExtraAction?.onCreateCollegeProgram}
          onCreateAdmissionBatch={props.onExtraAction?.onCreateAdmissionBatch}
          onViewCollegeUsers={props.onExtraAction?.onViewCollegeUsers}
          onViewCollegePrograms={props.onExtraAction?.onViewCollegePrograms}
          db_instance_id={props.onExtraAction?.db_instance_id}
          hasPermission={props.onExtraAction?.hasPermission}
        />
      ),
    });
    setOpenCollegesView(true);
    setCOpen(false);
    setSocietyId(society_id);
    setSocietyName(society_name);
  };
  const openCollegeProgramsView = async (college_id, college_name, program_id, program_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/bootstrap-program.php?action=list&college_id=${college_id}&db_instance_id=${user.db_instance_id}`,
      onEdit: handleCollegeProgramEdit,
      onDelete: handleCollegeProgramDelete,
      onExtraAction: {
        onCreateProgramBranch: openProgramBranchDialog,
        onViewProgramBranches: openProgramBranchesView,
        db_instance_id: user.db_instance_id,
        hasPermission,
      },
      setColumns: setCPColumns,
      setRows: setCPRows,
      customActionComponent: (props) => (
        <RowProgramActionsMenu
          {...props}
          onCreateProgramBranch={props.onExtraAction?.onCreateProgramBranch}
          onViewProgramBranches={props.onExtraAction?.onViewProgramBranches}
          db_instance_id={props.onExtraAction?.db_instance_id}
          hasPermission={props.onExtraAction?.hasPermission}
        />
      ),
    });
    setCPView(true);
    setCPOpen(false);
    setCollegeId(college_id);
    setCollegeName(college_name);
  };
  const openProgramBranchesView = async (program_id, college_id, program_name) => {
    await fetchTableData({
      url: `${API_BASE_URL}/bootstrap-branch.php?action=list&program_id=${program_id}&college_id=${college_id}&db_instance_id=${user.db_instance_id}`,
      onEdit: handleProgramBranchEdit,
      onDelete: handleProgramBranchDelete,
      onExtraAction: {
        onCreateProgramBranch: openProgramBranchDialog,
        onViewProgramBranches: openProgramBranchesView,
        db_instance_id: user.db_instance_id,
        hasPermission,
      },
      setColumns: setPBColumns,
      setRows: setPBRows,
      customActionComponent: (props) => (
        <RowBranchActionsMenu
          {...props}
          onCreateProgramBranch={props.onExtraAction?.onCreateProgramBranch}
          onViewProgramBranches={props.onExtraAction?.onViewProgramBranches}
          db_instance_id={props.onExtraAction?.db_instance_id}
          hasPermission={props.onExtraAction?.hasPermission}
        />
      ),
    });
    setPBView(true);
    setPBOpen(false);
    setProgramId(program_id);
    setProgramName(program_name);
  };
  const openCollegeLogoDialog = (college_id, college_name, society_id, college_logopath) => {
    setCollegeId(college_id);
    setCollegeName(college_name);
    setLogoDialogOpen(true);
    setExistsUrl(college_logopath);
  };
  const openCollegeDialog = (society_id, society_name, db_instance_id) => {
    setCollegeFormData({
      society_id,
      society_name,
      db_instance_id,
      college_name: "",
      is_college_active: "",
      college_code: "",
      college_refurl: "",
      college_email: "",
      college_validity: "",
      college_logopath: "",
    });
    setSOpen(true);
    setSEditingId(null);
    setSocietyId(society_id);
    setSocietyName(society_name);
    setCollegeFormErrors({});
  };
  const handleCollegeEdit = (row) => {
    setCollegeFormData({ ...row });
    setCEditingId(row.college_id);
    setCollegeId(row.college_id);
    setCollegeName(row.college_name);
    setCOpen(true);
  };
  const handleCollegeProgramEdit = (row) => {
    setCollegeProgramFormData({ ...row });
    setCPEditingId(row.program_id);
    setProgramId(row.program_id);
    setProgramName(row.program_name);
    setCPOpen(true);
  };
  const handleProgramBranchEdit = (row) => {
    setProgramBranchFormData({ ...row });
    setPBEditingId(row.branch_id);
    setBranchId(row.branch_id);
    setBranchName(row.branch_name);
    setPBOpen(true);
  };
  const handleAdmissionBatchEdit = (row) => {
    setAdmissionBatchFormData({ ...row });
    setABEditingId(row.admissionbatch_id);
    setAdmissionBatchId(row.admissionbatch_id);
    setAdmissionBatchName(row.admissionbatch_year);
    setABOpen(true);
  };
  const handleCollegeProgramDelete = async (program_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete Program?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      let response;
      try {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-program.php?action=delete&program_id=${program_id}&db_instance_id=${user.db_instance_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        if (response.status === 200) {
          showSnackbar(" Program Deleted successfully", "success");
        } else {
          showSnackbar(" Program is not Deleted ", "error");
        }
        openCollegeProgramsView(collegeId, collegeName);
      } catch (err) {
        showSnackbar("Error deleting program", "error");
      }
    }
  };
  const handleProgramBranchDelete = async (branch_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete Branch?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      let response;
      try {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-branch.php?action=delete&branch_id=${branch_id}&db_instance_id=${user.db_instance_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        if (response.status === 200) {
          showSnackbar(" Branch Deleted successfully", "success");
        } else {
          showSnackbar(" Branch is not Deleted ", "error");
        }
        openProgramBranchesView(programId, collegeId, programName);
      } catch (err) {
        showSnackbar("Error deleting program", "error");
      }
    }
  };
  const handleCollegeUploadLogo = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("client_id", user.client_id);
    formData.append("college_id", collegeId);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/bootstrap-college.php?action=upload&college_id=${collegeId}&db_instance_id=${user.db_instance_id}&client_id=${user.client_id}`,
        formData,
        {
          headers: {
            ...getAuthHeaders(),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        showSnackbar("Logo uploaded successfully.", "success");
      } else {
        showSnackbar(response.data.message || "Failed to upload logo", "error");
      }
    } catch (error) {
      console.error("Upload error:", error);
      showSnackbar("Error uploading logo", "error");
    }
  };

  const handleCollegeSave = async () => {
    const errors = {};

    if (!collegeFormData.college_name?.trim()) {
      errors.college_name = "College name is required";
    }

    if (!collegeFormData.college_code?.trim()) {
      errors.college_code = "College code is required";
    }

    if (collegeFormData.is_college_active === "") {
      errors.is_college_active = "Select active status";
    }
    if (collegeFormData.college_refurl === "") {
      errors.college_refurl = " Referal url is required";
    }
    if (collegeFormData.college_emaill === "") {
      errors.college_email = " Email is required to send GUID-Token";
    }

    setCollegeFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...collegeFormData,
        created_by: userName,
        client_id: clientId,
        db_instance_id: user.db_instance_id,
      };
      let response;
      if (ceditingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-collegeclient.php?action=update`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openCollegesView(clientId, societyId, societyName, dbinstanceId);
        showSnackbar(message, "success");
        alert("College is Created");
        setCollegeOpen(false);
      } else {
        showSnackbar("Failed to create college", "error");
      }
    } catch (error) {
      console.error("Error creating college:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleCollegeProgramSave = async () => {
    const errors = {};

    if (!collegeProgramFormData.program_name?.trim()) {
      errors.program_name = "Program name is required";
    }

    if (!collegeProgramFormData.program_desc?.trim()) {
      errors.program_desc = "Program description is required";
    }

    if (collegeFormData.is_program_active === "") {
      errors.is_program_active = "Select active status";
    }
    if (collegeFormData.program_duration === "") {
      errors.program_duration = " Program duration is required";
    }
    if (collegeFormData.program_start_year === "") {
      errors.program_start_year = " Program Started year is required";
    }

    setCollegeProgramFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...collegeProgramFormData,
        created_by: userName,
        updated_by: userName,
        college_id: collegeId,
        db_instance_id: user.db_instance_id,
      };
      let response;
      if (cpeditingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-program.php?action=update`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-program.php?action=create`,
          {
            created_by: userName,
            college_id: collegeId,
            db_instance_id: user.db_instance_id,
            ...collegeProgramFormData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openCollegeProgramsView(collegeId, collegeName);
        showSnackbar(message, "success");
        setCPOpen(false);
      } else {
        showSnackbar("Failed to create college", "error");
      }
    } catch (error) {
      console.error("Error creating college:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleSocietyUserDelete = async (user_id) => {
    const confirm2 = await Swal.fire({
      title: "Sure to delete Society User?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      willOpen: () => {
        const container = document.querySelector(".swal2-container");
        if (container) {
          container.style.zIndex = "20000";
        }
      },
    });

    if (confirm2.isConfirmed) {
      let response;
      try {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-auth.php?action=delete&user_id=${user_id}&db_instance_id=${user.db_instance_id}`,
          null,
          {
            headers: getAuthHeaders(),
          }
        );
        if (response.status === 200) {
          showSnackbar(" Society user Deleted successfully", "success");
        } else {
          showSnackbar(" Society User is not Deleted ", "error");
        }
        //fetchSocietyUsers(societyId);
      } catch (err) {
        alert(err);
        showSnackbar("Error deleting Fee Type", "error");
      }
    }
  };
  const handleSocietyUserSave = async () => {
    const errors = {};

    if (!societyUserFormData.user_email?.trim()) {
      errors.user_email = "User name is required";
    }

    if (!societyUserFormData.user_email?.trim()) {
      errors.user_email = "User Email is required";
    }

    setSocietyUserFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...societyUserFormData,
        created_by: userName,
        society_id: societyId,
        db_instance_id: dbinstanceId,
      };
      let response;
      if (sueditingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-auth.php?action=update&society_id=${societyId}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-auth.php?action=register&society_id=${societyId}`,
          {
            created_by: userName,
            ...societyUserFormData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openSocietyUsersView(societyId, societyName, dbinstanceId);
        showSnackbar(message, "success");
        alert("Society User is Created");
        setSUOpen(false);
      } else {
        showSnackbar("Failed to create Society user", "error");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleProgramBranchSave = async () => {
    const errors = {};

    if (!programBranchFormData.branch_name?.trim()) {
      errors.branch_name = "Branch name is required";
    }

    if (!programBranchFormData.branch_desc?.trim()) {
      errors.branch_desc = "Branch Description is required";
    }
    if (!programBranchFormData.branch_start_year === "") {
      errors.branch_start_year = "Branch Started Year is required";
    }

    if (!programBranchFormData.is_branch_active === "") {
      errors.is_branch_active = "Set Branch Active";
    }

    setProgramBranchFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...programBranchFormData,
        created_by: user.user_email,
        updated_by: userName,
        college_id: collegeId,
        program_id: programId,
        db_instance_id: user.db_instance_id,
      };
      let response;
      if (pbeditingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-branch.php?action=update&db_instance_id=${user.db_instance_id}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-branch.php?action=create&db_instance_id=${user.db_instance_id}`,
          {
            created_by: userName,
            updated_by: userName,
            college_id: collegeId,
            program_id: programId,
            db_instance_id: user.db_instance_id,
            ...programBranchFormData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openProgramBranchesView(programId, collegeId, programName, user.db_instance_id);
        showSnackbar(message, "success");
        setPBOpen(false);
      } else {
        showSnackbar("Failed to create  branch", "error");
      }
    } catch (error) {
      console.error("Error creating branch:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const handleAdmissionBatchSave = async () => {
    const errors = {};

    if (!admissionBatchFormData.admissionbatch_year?.trim()) {
      errors.admissionbatch_year = "Admission batch year is required";
    }
    if (!admissionBatchFormData.is_active === "") {
      errors.is_active = "Set Admission Year Active";
    }

    setAdmissionBatchFormErrors(errors);

    if (Object.keys(errors).length > 0) return;
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userName = user?.user_email || "unknown";
      const payload = {
        ...admissionBatchFormData,
        created_by: user.user_email,
        updated_by: userName,
        college_id: collegeId,
        db_instance_id: user.db_instance_id,
      };
      let response;
      if (abeditingId) {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-admissionbatch.php?action=update&db_instance_id=${user.db_instance_id}`,
          payload,
          {
            headers: getAuthHeaders(),
          }
        );
      } else {
        response = await axios.post(
          `${API_BASE_URL}/bootstrap-admissionbatch.php?action=create&db_instance_id=${user.db_instance_id}`,
          {
            created_by: userName,
            updated_by: userName,
            college_id: collegeId,
            db_instance_id: user.db_instance_id,
            ...admissionBatchFormData,
          },
          {
            headers: getAuthHeaders(),
          }
        );
      }
      if (response.status === 200) {
        const { success, message } = response.data;
        openAdmissionBatchesView(collegeId, collegeName, user.db_instance_id);
        showSnackbar(message, "success");
        setABOpen(false);
      } else {
        showSnackbar("Failed to create  admitted batch", "error");
      }
    } catch (error) {
      console.error("Error creating admission batch:", error);
      showSnackbar("Error occurred during save", "error");
    }
  };
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const societyfields = [
    {
      name: "society_name",
      label: "Socety Name",
      type: "text",
    },
    {
      name: "society_code",
      label: "Socety code",
      type: "text",
    },
    {
      name: "society_email",
      label: "Socety Email",
      type: "text",
    },
  ].filter(Boolean);

  const societyuserfields = [
    {
      name: "user_email",
      label: "User Name",
      type: "text",
    },
    {
      name: "user_emaile",
      label: "User Email",
      type: "email",
    },
  ].filter(Boolean);
  const collegefields = [
    {
      name: "college_name",
      label: "College Name",
      type: "text",
    },
    {
      name: "college_code",
      label: "College code",
      type: "text",
    },
    {
      name: "college_refurl",
      label: "College Url",
      type: "number",
    },
    {
      name: "college_email",
      label: "College Email",
      type: "number",
    },
    {
      name: "is_college_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const collegeprogramfields = [
    {
      name: "program_name",
      label: "Program Name",
      type: "text",
    },
    {
      name: "program_desc",
      label: "Program Description",
      type: "text",
    },
    {
      name: "program_duration",
      label: "Program Duration",
      type: "number",
    },
    {
      name: "program_start_year",
      label: "Program StartYear",
      type: "number",
    },
    {
      name: "is_program_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const programbranchfields = [
    {
      name: "branch_name",
      label: "Branch Name",
      type: "text",
    },
    {
      name: "branch_desc",
      label: "Branch Description",
      type: "text",
    },
    {
      name: "branch_start_year",
      label: "Branch StartYear",
      type: "number",
    },
    {
      name: "is_branch_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const admissionbatchfields = [
    {
      name: "admissionbatch_year",
      label: "Admission Batch Year",
      type: "number",
    },
    {
      name: "is_active",
      label: "Is Active",
      type: "select",
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    },
  ].filter(Boolean);
  const handleSocietyChange = (name, value) => {
    setSocietyFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSocietyUserChange = (name, value) => {
    setSocietyUserFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCollegeChange = (name, value) => {
    setCollegeFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleCollegeProgramChange = (name, value) => {
    setCollegeProgramFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleProgramBranchChange = (name, value) => {
    setProgramBranchFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAdmissionBatchChange = (name, value) => {
    setAdmissionBatchFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <DashboardLayoutMin>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" color="white">
                    SOCIETIES MANAGEMENT
                  </MDTypography>
                </MDBox>
              </MDBox>
              {scolumns.length > 0 && srows.length > 0 && (
                <MDBox pt={2}>
                  <DataTable
                    table={{ columns: scolumns, rows: srows }}
                    isSorted={true}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    canSearch={true}
                    noEndBorder
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      <LogoDialog
        open={logoDialogOpen}
        onClose={() => setLogoDialogOpen(false)}
        onUpload={handleCollegeUploadLogo}
        existingLogoUrl={existUrl}
      />

      <DynamicDialog
        open={sopen}
        onClose={() => setSOpen(false)}
        title={seditingId ? "Edit Society " : "Add Society"}
        formData={societyFormData}
        formErrors={societyFormErrors}
        fields={societyfields}
        onChange={handleSocietyChange}
        onSave={handleSocietySave}
      />
      <DynamicDialog
        open={suopen}
        onClose={() => setSUOpen(false)}
        title={
          sueditingId
            ? "Edit Society user of " + `${societyName}`
            : "Add Society user for " + `${societyName}`
        }
        formData={societyUserFormData}
        formErrors={societyUserFormErrors}
        fields={societyuserfields}
        onChange={handleSocietyUserChange}
        onSave={handleSocietyUserSave}
      />
      <DynamicDialog
        open={copen}
        onClose={() => setCOpen(false)}
        title={
          ceditingId ? "Edit College of " + `${societyName}` : "Add College for " + `${societyName}`
        }
        formData={collegeFormData}
        formErrors={collegeFormErrors}
        fields={collegefields}
        onChange={handleCollegeChange}
        onSave={handleCollegeSave}
      />
      <DynamicDialog
        open={abopen}
        onClose={() => setABOpen(false)}
        title={
          abeditingId
            ? "Edit Admission Batch of " + `${collegeName}`
            : "Add Admission Batch for " + `${collegeName}`
        }
        formData={admissionBatchFormData}
        formErrors={admissionBatchFormErrors}
        fields={admissionbatchfields}
        onChange={handleAdmissionBatchChange}
        onSave={handleAdmissionBatchSave}
      />
      <DynamicDialog
        open={cpopen}
        onClose={() => setCPOpen(false)}
        title={
          cpeditingId
            ? "Edit Program of " + `${collegeName}`
            : "Add Program for " + `${collegeName}`
        }
        formData={collegeProgramFormData}
        formErrors={collegeProgramFormErrors}
        fields={collegeprogramfields}
        onChange={handleCollegeProgramChange}
        onSave={handleCollegeProgramSave}
      />
      <DynamicDialog
        open={pbopen}
        onClose={() => setPBOpen(false)}
        title={
          pbeditingId ? "Edit Branch of " + `${programName}` : "Add Branch for " + `${programName}`
        }
        formData={programBranchFormData}
        formErrors={programBranchFormErrors}
        fields={programbranchfields}
        onChange={handleProgramBranchChange}
        onSave={handleProgramBranchSave}
      />
      <Dialog
        open={openCollegesData}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpenCollegesView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Colleges List of Society: {societyName}
          <IconButton onClick={() => setOpenCollegesView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: ccolumns, rows: crows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenCollegesView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={cpview}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setCPView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Programs List of college: {collegeName}
          <IconButton onClick={() => setCPView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: cpcolumns, rows: cprows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setCPView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={pbview}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setPBView(false);
          }
        }}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "none",
            zIndex: 2000,
          },
        }}
      >
        <DialogTitle>
          Branches List of Program: {programName}
          <IconButton onClick={() => setPBView(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            background: "linear-gradient(to bottom,hsl(233, 24.30%, 92.70%),rgb(206, 213, 225))",
            padding: 2,
          }}
        >
          <MDBox pt={2}>
            <DataTable
              table={{ columns: pbcolumns, rows: pbrows }}
              isSorted={true}
              entriesPerPage={true}
              showTotalEntries={true}
              canSearch={true}
              noEndBorder
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => setPBView(false)}
            sx={{
              background: "linear-gradient(45deg,rgb(239, 43, 21),rgb(224, 73, 31))",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(45deg,rgb(210, 77, 25),rgb(242, 122, 53))",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayoutMin>
  );
}
SocietyClient.propTypes = {
  onExtraAction: PropTypes.shape({
    onUploadLogo: PropTypes.func,
    onCreateSocietyUser: PropTypes.func,
    onCreateCollegeUser: PropTypes.func,
    onCreateCollegeProgram: PropTypes.func,
    onViewSocietyUsers: PropTypes.func,
    onViewColleges: PropTypes.func,
    onViewCollegeUsers: PropTypes.func,
    onViewCollegePrograms: PropTypes.func,
    onCreateProgramBranch: PropTypes.func,
    onViewProgramBranches: PropTypes.func,
    onCreateAdmissionBatch: PropTypes.func,
    db_instance_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hasPermission: PropTypes.func,
  }),
};
export default SocietyClient;
